import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { RootLayout } from '../_components';
import { Login } from '../Auth';
import { BookmarkList } from '../Bookmark/BookmarkList';
import { Course } from '../Course/Course';
import { CourseList } from '../Course/CourseList';
import { Subject } from '../Course/Subject';
import { EdraaquizLeaderBoard } from '../Exam/EdraaquizLeaderBoard';
import { Exam } from '../Exam/Exam';
import { ExamResult } from '../Exam/ExamResult';
import { GrandQuiz } from '../Exam/GrandQuiz';
import { MockTest } from '../Exam/MockTest';
import Home from '../Home/Home';
import DeleteAccount from '../Home/DeleteAccount';
import { SeriesSingleView } from '../Home/SeriesSingleView';
import { useUser } from '../Hook/useUser';
import { NoteSingleView } from '../Notes/NoteSingleView';
import Profile from '../Profile/Profile';
import PaymentFail from '../Subscription/PaymentFail';
import PaymentHistory from '../Subscription/PaymentHistory';
import PaymentSuccess from '../Subscription/PaymentSuccess';
import { UserContext } from '../Utils/Contexts';

export default function Router() {
  const user = useUser();
  return (
    <>
      <UserContext.Provider value={user}>
        <Routes>
          <Route path='' element={<RootLayout />}>
            <Route index element={<Home />} />
            <Route path='courselist' element={<CourseList />} />
            <Route path='course/:id' element={<Course />} />
            <Route path='topiclist/:id' element={<Subject />} />
            <Route path='Exam' element={<Exam />} />
            <Route path='examresult' element={<ExamResult />} />
            <Route path='profile' element={<Profile />} />
            <Route path='bookmarklist' element={<BookmarkList />} />
            <Route path='mocktest' element={<MockTest />} />
            <Route path='grandquiz' element={<GrandQuiz />} />
            <Route path='edraaquizresult' element={<EdraaquizLeaderBoard />} />
            <Route path='/hi_payment_success/:id' element={<PaymentSuccess />} />
            <Route path='/hi_payment_failed' element={<PaymentFail />} />
            <Route path='/Payment_history' element={<PaymentHistory />} />
            <Route path='/series_single' element={<SeriesSingleView />} />
            <Route path='/notesingle' element={<NoteSingleView />} />
          </Route>

          <Route path='/login' element={<Login />} />
          <Route path='/delete-account' element={<DeleteAccount />} />
        </Routes>
      </UserContext.Provider>
    </>
  );
}
